import React from 'react';
import TreeListItem from './tree-list-item';
import classnames from 'classnames';

class TreeList extends React.Component {
  render(){
    const { items, collapsed, components, componentMatches, styleOverride, onSelect, selected, selectable } = this.props;

    const listClass = classnames({
      "tree-list": true,
      "hidden": collapsed
    })

    return (
      <ul className={listClass} style={styleOverride}>
        {
          items.map(function(item){
            return <TreeListItem 
              key={item.uid} 
              item={item} 
              components={components} 
              componentMatches={componentMatches}
              onSelect={onSelect}
              selected={selected}
              selectable={selectable}
              time={new Date()}
            />
          })
        }
      </ul>
    )
  }
}

export default TreeList;